/* @flow
 *
 * Allows the parent menu to be opened and closed on the homepage.
 */

import $ from 'jquery';

$(() => {
  const control = $('[data-control=parent-menu]');
  const menu = $('[data-toggle=parent-menu]');
  const behavior = $('[data-behavior=parent-menu]');
  const openMenu = (): void => {
    menu.toggleClass('is-hidden');
    behavior.toggleClass('parent-menu--visible');
  };
  control.on('click', () => {
    openMenu();
    return false;
  });
});
